import { createAction, props } from '@ngrx/store';
import { WebshopPublicDataDto } from './webshop.models';

export const loadWebshopData = createAction(
  '[Webshop] Load Webshop Data'
);

export const loadWebshopDataSuccess = createAction(
  '[Webshop] Load Webshop Data Success',
  props<{ data: WebshopPublicDataDto }>()
);

export const loadWebshopDataFailure = createAction(
  '[Webshop] Load Webshop Data Failure',
  props<{ error: any }>()
);

export const setSearchTerm = createAction(
  '[Webshop] Set Search Term',
  props<{ searchTerm: string }>()
);
